import React, { useState, useEffect } from "react";
import {
  Button,
  Dropdown,
  Modal,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import LogoutPage from "./Logout";
import logo from "../../../icons/photos/chillLogo.png";
import { useDispatch, useSelector } from "react-redux";
import profile from "../../../images/banner-img/pic-1.png";
import { NavMenuToggle } from "./NavHader";
import InviteFriend from "../../../pages/inviteFriend/inviteFriend";
import ChangePassword from "../../../pages/changePassword/changePassword";
import { getCountryCode } from "../../../service/api/countryCode/countryCode";
import { setCountryArray } from "../../../feature/countryArray/countryArray";
import { unreadNotificationCount } from "../../../service/api/notification/unreadNotification";
import { userNotificationCount } from "../../../service/api/notification/userNotification";
import { singleNotification } from "../../../service/api/notification/singleNotificationDetails";
import { deleteNotification } from "../../../service/api/notification/deleteNotification";
import { requestForToken, setMessageListener } from "../../../firebase";
import { BsArrowLeft, BsArrowLeftSquareFill } from "react-icons/bs";
import feedbackIcon from "../../../icons/chilllIcons/icon.svg"
import {
  backDropLoaderRejectedCaseRedux,
  backLoaderFalse,
  callTrue,
  notificationReduxState,
  setActiveCall,
  setFeedbackModalRedux,
  setImpersonateAccessToken,
  setImpersonateFlag,
  setImpersonateRefreshToken,
  setInactiveCall,
  setIsCheckInCall,
  setIsSignUpFlagFalse,
  setLoaderTime,
  setTotalMonthlyFreeVideoLink,
  setUserProfileTab,
  updateBackDropLoaderWithoutStateFalse,
} from "../../../feature/userData/userData";
import imageLogo from '../../../media/images/logo.png'

import {
  setUserDetails,
  setNotificationCount,
} from "../../../feature/userData/userData";
import { userById } from "../../../service/api/user/userById";
import { addFCMToken } from "../../../service/api/user/addFCMToken";
import PhoneCallModal from "../../../component/phoneCallModal/phoneCallModal";
import FcmTokenVerify from "../../../component/fcmTokenVerify/fcmTokenVerify";
import {
  btnChangePassword,
  btnInviteFriends,
  btnPersonal,
} from "../../../dataBaseFile/alert";
import io from "socket.io-client";
import { bulkReadDeleteNotification } from "../../../service/api/notification/bulkReadDelete";
import ResponceToaster from "../../components/responceToaster/responceToaster";
import updateAvailabilityApi from "../../../service/api/user/updateAvailability";
import { BiReset } from "react-icons/bi";
import AcceptRejectModal from "../../components/modalAcceptReject/modalAcceptreject";
import { PiUserSwitchBold } from "react-icons/pi";
import SwitchRole from "../../components/switchRole/switchRole";
import FeedbackModal from "../../components/feedback/feedback";
import ErrorResponseModal from "../../../component/errorModal/errorResponseModal";
import SkeletonDivElement from "../../../component/skeletonTableRow/skeletonDivElement";
import bell from "../../../media/images/bell.png"
import { getCounterApi } from "../../../service/api/ticket/serviceCounters";
import updateServiceRequestoptionApi from "../../../service/api/user/updateServiceRequestoption";
import PrimaryButton from "../../components/button/primaryButton";
import { getCompanyInvitationApi } from "../../../service/api/companies/getCompanyInvitation";
import acceptCompanyInvitationApi from "../../../service/api/companies/acceptCompanyInvitation";
import { getActiveCallsApi } from "../../../service/api/ticket/getActiveCalls";
import { switchRoleApi } from "../../../service/api/user/switchRole";
import updateProOptionApi from "../../../service/api/user/updateProOption";
function AddSearchSlider() {
  //alert(111);
  let SearchBlog = document.getElementById("Search-Blog");
  let BoxTab = document.getElementById("close-searchbox");
  setTimeout(() => {
    if (BoxTab.classList.contains("active")) {
      return (
        BoxTab.classList.remove("active"), SearchBlog.classList.remove("active")
      );
    } else {
      return BoxTab.classList.add("active"), SearchBlog.classList.add("active");
    }
  }, 100);
}

const Header = ({ onNote }) => {
  const {
    userName,
    userLastName,
    currentPage,
    impersonateRefreshToken,
    impersonateUserId,
    impersonateAccessToken,
    impersonateRoleId,
    profilePicture,
    notificationCount,
    callStatus,
    backDropLoaderRejectedCase,
    backDropLoaderStatus,
    role,
    impersonateFlag,
    companyId,
    activeSubscriptionEndTime,
    isFreeTrialSubscription,
    permissionArr = [],
    roleArr,
    roleDisplayName,
    serviceRequestOptions,
    serviceRequestFlagPro,
    isActiveCall,
    subscriptionType,
    subscriptionPaidStatus,
    isSignUpFlag,
    proExpertiseFlag,
    proDocumentsFlag,
    feedbackModalRedux,
    downloadAppBar,
    totalCreditsInCents,
    proOptionList,
    proOptionFlag,
  } = useSelector((state) => state.user) ?? {};

  const tabPermission =
    (Array.isArray(permissionArr) && permissionArr[0]) || [];
  const [toggle, setToggle] = useState(false);
  const [headerFix, setheaderFix] = useState(false);
  const [messages, setMessages] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toasterType, setToasterType] = useState("");
  const [handleToaster, setHandleToaster] = useState(false);
  const [responceMsg, setResponceMsg] = useState("");

  const [FcmModalTrigger, setFcmModalTrigger] = useState(false);
  const handleCloseFCM = () => setFcmModalTrigger(false);

  const [impersonateModal, setImpersonateModal] = useState(false);
  const [switchRoleModal, setSwitchRoleModal] = useState(false);
  // const [roleArr, setRoleArr] = useState([]);
  const [changedRoleId, setChangedRoleId] = useState();
  const [roleName, setRoleName] = useState("");
  const [companyAddCheck, setCompanyAddCheck] = useState(false);
  const [errorModalStatus, setErrorModalStatus] = useState(false)

  const [errorMessage, setErrorMessage] = useState("");

  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [subscriptionString, setSubscriptionString] = useState("");
  const [subscriptionTimeLeft, setSubscriptionTimeLeft] = useState(0);

  const permissionArray = tabPermission;
  const [activeCalls, setActiveCalls] = useState([])
  const [callModal, setCallModal] = useState(false)
  const [checkActiveCall, setCheckActiveCall] = useState(new Date().getTime());

  const [globalNotificationModalTrigger, setGlobalNotificationModalTrigger] = useState(false);

  const [globalNotificationData, setGlobalNotificationData] = useState({});

  useEffect(() => {

    permissionArray.includes("SERVICE REQUEST TAB") && activeCallOnLoad()
    function activeCallOnLoad() {
      let details = {
        scheduled_tickets_flag: 2,
      };
      dispatch(
        getActiveCallsApi(
          details,
          (res) => {
            setActiveCalls(res.data.active_calls)
            const myVal = JSON.parse(localStorage.getItem("isDisconnectedCall"))
            if (!myVal) {
              if (res?.data?.active_calls?.length > 0) {
                dispatch(setActiveCall())
              } else {
                dispatch(setInactiveCall())
              }
            }
          },
          () => { }
        )
      );
    }
  }, [checkActiveCall]);

  useEffect(() => {
    const myVal = JSON.parse(localStorage.getItem("isDisconnectedCall"))
    if (myVal) {
      const id = setTimeout(() => {
        localStorage.setItem("isDisconnectedCall", JSON.stringify(false))
      }, 10000)
      return () => {
        clearTimeout(id)
      }
    }
  }, [localStorage.getItem("isDisconnectedCall")])

  // useEffect(() => {
  //   if (isActiveCall) {
  //     const id = setTimeout(() => {
  //       dispatch(setInactiveCall())
  //     }, 4000)
  //     return () => {
  //       clearTimeout(id)
  //     }
  //   }
  // }, [isActiveCall])

  function handleGetUserById() {
    let user = {
      user_id_ids: localStorage.getItem("user_id"),
      role_id_int: localStorage.getItem("roleId"),
      user_impersonate_flag: 0,
    };
    dispatch(
      userById(user, (res) => {
        dispatch(setUserDetails(res.data.data));
        dispatch(setLoaderTime(res.data));
        dispatch(setTotalMonthlyFreeVideoLink(res.data))
        // setRoleArr(res.data.data.roles);
        setChangedRoleId(res.data.data.role_id_int);
        setRoleName(res.data.data.role_display_name_chr);
        // console.log(`${res.data.data.is_active_ysn} res.data.data.is_active_ysn`)
        localStorage.setItem("triggerFlag", res.data.data.is_available_ysn);
      })
    );
  }

  useEffect(() => {
    if (companyId) {
      if (companyAddCheck) {
        handleGetUserById() && permissionArray.includes("PROFILE  TAB")
      }
    }
    setCompanyAddCheck(true);
  }, [companyId]);



  useEffect(() => {
    let details = {};
    dispatch(
      getCountryCode(
        details,
        (res) => {
          dispatch(setCountryArray(res.data));
        },
        (err) => { }
      )
    );
    handleGetUserById() && permissionArray.includes("PROFILE  TAB");
    let userN = {
      user_id_ids: localStorage.getItem("user_id"),
    };
    permissionArray.includes("VIEW NOTIFICATION LIST") && dispatch(
      unreadNotificationCount(userN, (res) => {
        dispatch(setNotificationCount(res.data.data.count));
      })
    );
  }, []);



  useEffect(() => {
    // for header fix on scroll
    window.addEventListener("scroll", () => {
      setheaderFix(window.scrollY > 50);
    });

    welcomeDate();

    dispatch(setIsCheckInCall(false));

  }, []);

  const [currentDate, setCurrentDate] = useState("");
  const welcomeDate = () => {
    const nameOfMonthUS = new Intl.DateTimeFormat("en-US", {
      month: "long",
    }).format(new Date());
    var dateObj = new Date();
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    setCurrentDate(`${day} ${nameOfMonthUS}, ${year}`);
  };

  const notificationPage = () => {
    navigate("/notificationPage");
  };

  // Modal triggers for the Invite Friend
  const [showInviteFriend, setShowInviteFriend] = useState(false);

  const handleCloseInviteFriend = () => setShowInviteFriend(false);
  const handleShowInviteFriend = () => setShowInviteFriend(true);

  // Modal triggers for the Change Password
  const [showChangePassword, setShowChnagePassword] = useState(false);

  const handleCloseChangePassword = (data, message) => {
    if (data == "success") {
      setToasterType("success");
      setHandleToaster(true);

      setResponceMsg(message);
      setTimeout(() => {
        setHandleToaster(false);
      }, 5000);
    }
    setShowChnagePassword(false);
  };
  const handleShowChangePassword = () => setShowChnagePassword(true);
  const [notificationArr, setNotificationArr] = useState([]);
  const [notificationLoading, setNotificationLoading] = useState(false);

  const handleClickNotification = (event) => {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      page_index: 1,
      page_size: 16,
      order: "DESC",
      column_name: "",
      search_by: "",
      search_area: "",
    };

    setNotificationLoading(true);
    dispatch(
      userNotificationCount(
        details,
        (res) => {
          setNotificationArr(res.data.data);

          setNotificationLoading(false);

          dispatch(
            setNotificationCount(res.data.unread_notification_count.count)
          );
        },
        (err) => {
          setNotificationLoading(false);
        }
      )
    );
  };

  const handleMenuItemClick = (nI, cI, nT, tI, ticket_id_lng) => {
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      notification_id_ids: nI,
    };
    dispatch(
      singleNotification(details, (res) => {
        //  code to navigate to respective route as per notification type
        if (nT === 0) {
          navigate("/notificationPage");
        } else if (nT === 1) {
          navigate("/waitingUserDashboard");
        } else if (nT === 2) {
          navigate("/serviceRequest");
        } else if (nT === 8) {
          navigate('/userProfile')
          dispatch(setUserProfileTab(3))
        } else if (nT === 9 || nT === 10) {
          navigate("/companyRequests");
        } else if (nT === 13) {
          navigate('/notificationDetails');

          localStorage.setItem('notifcation_id', nI)
        }

        if (ticket_id_lng) {
          localStorage.setItem("ticket_id", ticket_id_lng);
          navigate("/serviceRequestDetails");
        }
      })
    );
  };

  const deleteSingleDetails = (e, key) => {
    let array = [...notificationArr];
    array.splice(key, 1);
    setNotificationArr(array);
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      notification_id_ids: e,
    };
    setNotificationsLoading(true);
    dispatch(
      deleteNotification(details, (res) => {
        handleClickNotification();
        setNotificationsLoading(false);
      }, (err) => {
        setNotificationsLoading(false);
      })
    );
  };
  const [recievedFromServer, setRecievedFromServer] = useState({});
  var socket = undefined;
  useEffect(() => {
    socket = io(process.env.REACT_APP_ENV, {
      query: {
        user_id_ids: localStorage.getItem("user_id"),
        device_type_chr: "BROWSER",
      },
    });

    socket.on("connect", () => {
      console.log("Connected to IB WebSocket");
      // Subscribe to specific data streams using socket.emit
    });

    socket.on("message", (message) => {
      // Handle incoming message
      // console.log('Received message:', message);
      // Update state to store the received messages
      // setMessages((prevMessages) => [...prevMessages, message]);
    });

    socket.on("server_response", (payload) => {
      // Handle incoming message
      console.log(payload, "payload");
      if (payload.data.ticket_id_ids) {
        localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
      }
      if (payload.data.notification_type != "12") {
        setRecievedFromServer(payload);
      }
      if (payload.data.user_id_ids == localStorage.getItem("user_id")) {
        console.log("Received:", payload);
        let details = {
          user_id_ids: localStorage.getItem("user_id"),
        };
        dispatch(
          unreadNotificationCount(details, (res) => {
            dispatch(setNotificationCount(res.data.data.count));
          })
        );

        if (payload.data.notification_type != "12") {
          dispatch(notificationReduxState(payload));
        }
        if (!callStatus) {
          if (payload.data.notification_type == "2") {
            localStorage.setItem("metaData", payload.data.meta_data);
            const sentence = payload.data.body;
            const words = sentence?.split(" ");
            localStorage.setItem("callingName", words[0]);
            dispatch(callTrue());
          } else
            if (payload.data.notification_type == "4") {
              if (backDropLoaderStatus) {
                dispatch(backLoaderFalse());
                dispatch(updateBackDropLoaderWithoutStateFalse());
                localStorage.setItem("roomCode", payload.data.room_id);
                localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
                // navigate("/particularTicketDetails");
                navigate("/videoCall");
              }
              if (backDropLoaderRejectedCase) {
                dispatch(backDropLoaderRejectedCaseRedux());
                dispatch(updateBackDropLoaderWithoutStateFalse());
                localStorage.setItem("roomCode", payload.data.room_id);
                localStorage.setItem("ticket_id", payload.data.ticket_id_ids);
                // navigate("/particularTicketDetails");
                navigate("/videoCall");
              }
            }
            else if (payload.data.notification_type == "0") {
              if (payload.data.trigger_call_flag == "1") {
                const sentence = payload.data.body;
                const words = sentence?.split(" ");
                localStorage.setItem("callingName", words[0]);
                localStorage.setItem("roomCode", payload.data.room_id);
                localStorage.setItem("videoLink", payload.data.video_link);
                dispatch(callTrue());
              }
            } else

              if (payload.data.notification_type == "3") {
                dispatch(backDropLoaderRejectedCaseRedux(true));
                dispatch(backLoaderFalse());
              } else if (payload.data.notification_type == "8") {
                dispatch(backLoaderFalse());
                setErrorMessage(payload.data.body)
                setErrorModalStatus(true)
              } else if (payload.data.notification_type == "13") {
                // console.log(payload.data, "notificationDetails");
                setGlobalNotificationData(payload.data);
                setGlobalNotificationModalTrigger(true);
              }
        }
        if (payload.data.notification_type == "12") {
          setCheckActiveCall(new Date().getTime());
          localStorage.setItem("updateCustomerDashboard", new Date().getTime());
        }
      } else {
        console.log("not mine");
      }

      // Update state to store the received messages
      // setMessages((prevMessages) => [...prevMessages, message]);
    });
    return () => {
      socket.disconnect();
    };
  }, [backDropLoaderStatus, callStatus]);

  window.addEventListener("beforeunload", () => {
    socket.disconnect();
  });

  function handleReadAllNotification() {
    setNotificationsLoading(true);
    let data = {
      user_id_ids: localStorage.getItem("user_id"),
      action: "R",
      action_type: "A",
      notification_id_list: [],
    };
    dispatch(
      bulkReadDeleteNotification(
        data,
        () => {
          setNotificationsLoading(false);
          let details = {
            user_id_ids: localStorage.getItem("user_id"),
          };
          dispatch(
            unreadNotificationCount(details, (res) => {
              dispatch(setNotificationCount(res.data.data.count));
            })
          );
        },
        () => {
          setNotificationsLoading(false);
        }
      )
    );
  }

  function downloadURLShortcut(url, filename) {
    // 1. Generate the content for a .url file
    const urlFileContent = `[InternetShortcut]
URL=${url}`;

    // 2. Create a Blob with the .url content
    const blob = new Blob([urlFileContent], {
      type: "text/plain;charset=utf-8",
    });

    // 3. Create a temporary download link and click it
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = URL.createObjectURL(blob);
    a.download = filename || "shortcut.url";

    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }
  const shortcut = (
    <Tooltip id="tooltip">
      <strong>Create url shortcut</strong>
    </Tooltip>
  );
  const notificationShr = (
    <Tooltip id="tooltip">
      <strong>Notifications</strong>
    </Tooltip>
  );

  const impersonate = (
    <Tooltip id="tooltip">
      {" "}
      <strong>Revert impersonate</strong>
    </Tooltip>
  );
  const feedback = (
    <Tooltip id="tooltip">
      {" "}
      <strong>Feedback</strong>
    </Tooltip>
  );

  const activeCall = (
    <Tooltip id="tooltip">
      {" "}
      <strong>Active Call</strong>
    </Tooltip>
  );

  const upgradeSubscription = (
    <Tooltip id="tooltip">
      {" "}
      <strong>{subscriptionString}</strong>
    </Tooltip>
  );

  const getSubscriptionDaysLeft = (unixEndDate) => {
    const currentDate = new Date().getTime(); // Get current date in UNIX timestamp (milliseconds)
    const subscriptionEndDate = unixEndDate * 1000; // Convert UNIX timestamp from seconds to milliseconds

    // Calculate the difference in time (milliseconds)
    const timeDiff = subscriptionEndDate - currentDate;

    // Convert time difference from milliseconds to days
    // const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));


    if (daysLeft >= 0) {
      setSubscriptionTimeLeft(daysLeft);
    } else {
      setSubscriptionTimeLeft(0);
    }

    if (daysLeft > 0) {
      return `You have ${daysLeft} day(s) left in your subscription.`;
    } else if (daysLeft === 0) {
      return "Your subscription ends today.";
    } else {
      return "Buy subscription";
    }
  }


  useEffect(() => {
    setSubscriptionString(getSubscriptionDaysLeft(activeSubscriptionEndTime));
  }, [activeSubscriptionEndTime]);

  const handleDashboard = () => {
    navigate("/dashboard");
  };

  const [isChecked, setIsChecked] = useState(false);
  const [firstCheck, setFirstCheck] = useState(false);
  const [loaderEffect, setLoaderEffect] = useState(false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    setFirstCheck(true);
  };

  useEffect(() => {
    if (parseInt(localStorage.getItem("triggerFlag")) == 1) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  }, [localStorage.getItem("triggerFlag")]);

  useEffect(() => {
    if (firstCheck) {
      setLoaderEffect(true);
      let details = new FormData();

      details.append("user_id_ids", localStorage.getItem("user_id"));
      details.append("user_availability_flag", isChecked ? 1 : 0);
      dispatch(
        updateAvailabilityApi(
          details,
          (res) => {
            isChecked
              ? localStorage.setItem("triggerFlag", 1)
              : localStorage.setItem("triggerFlag", 0);
            setLoaderEffect(false);
          },
          (err) => {
            setLoaderEffect(false);
            alert("Update availability error");
          }
        )
      );
    }
  }, [isChecked]);

  function handleRevertimpersonate() {
    navigate("/dashboard");
    setImpersonateModal(false);
    dispatch(setImpersonateFlag(false));
    localStorage.setItem("user_id", impersonateUserId);
    localStorage.setItem("roleId", impersonateRoleId);
    localStorage.setItem("access_token", impersonateAccessToken);
    localStorage.setItem("refresh_token", impersonateRefreshToken);
    handleGetUserById();
  }

  function handleSwitchRoleModalClose() {
    setSwitchRoleModal(false);
  }
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackModal, setFeedbackModal] = useState(feedbackModalRedux);

  useEffect(() => {
    if (feedbackModal) {
      dispatch(setFeedbackModalRedux(true));
    } else if (!feedbackModal) {
      dispatch(setFeedbackModalRedux(false));
    }
  }, [feedbackModal])

  useEffect(() => {
    if (feedbackModalRedux) {
      setFeedbackModal(true)
    }
  }, [feedbackModalRedux])

  function handleFeedbackModal(type, message) {
    setFeedbackMessage(message);
    setToasterType(type)
    setResponceMsg(message)
    setFeedbackModal(false);
    setHandleToaster(true);
    setTimeout(() => {
      setHandleToaster(false);
    }, 11000);
  }

  const [useChilllModalTrigger, setUseChilllModalTrigger] = useState(false);
  const [serviceReqOptionId, setServiceReqOptionId] = useState(serviceRequestFlagPro);
  const [serviceReqOptionErr, setServiceReqOptionErr] = useState(false);
  const [serviceReqOptionLoading, setServiceReqOptionLoading] = useState(false);

  useEffect(() => {
    if (serviceRequestFlagPro) {
      setServiceReqOptionId(serviceRequestFlagPro);
    }
  }, [serviceRequestFlagPro])


  const handleOpenUseChilllModal = () => {
    setUseChilllModalTrigger(true);
  }

  const handleCloseUseChilllModal = () => {
    setUseChilllModalTrigger(false);
  }

  const handleServiceRequestoption = (ele) => {
    setServiceReqOptionId(ele.option_id_ids);
    setServiceReqOptionErr(false);
  }

  const handleSubmitServiceReqOption = () => {
    if (serviceReqOptionId) {
      setServiceReqOptionLoading(true);
      let data = new FormData();
      data.append('user_id_ids', localStorage.getItem('user_id'));
      data.append('service_request_flag', serviceReqOptionId);

      dispatch(
        updateServiceRequestoptionApi(data,
          (res) => {
            setServiceReqOptionLoading(false);
            setResponceMsg(res.data.message)
            // setToasterType("success")
            handleCloseUseChilllModal();
            // setHandleToaster(true);
            handleGetUserById();

            if (serviceReqOptionId !== 1 && !proExpertiseFlag && !proDocumentsFlag) {
              navigate("/onBoardPro");
            }

            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 5000);
          },
          (res) => {
            setServiceReqOptionLoading(false);
            setResponceMsg(res.data.message)
            setToasterType("error")
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 5000);
          })
      )
    } else {
      setServiceReqOptionErr(true);
    }
  }

  // ---- Update Pro Option function starts here -------
  const [proOptionModalTrigger, setProOptionModalTrigger] = useState(false);
  const [proOptionId, setProOptionId] = useState(proOptionFlag);
  const [proOptionErr, setProOptionErr] = useState(false);
  const [proOptionLoading, setProOptionLoading] = useState(false);

  useEffect(() => {
    if (proOptionFlag) {
      setProOptionId(proOptionFlag);
    }
  }, [proOptionFlag])


  const handleOpenProOptionModal = () => {
    setProOptionModalTrigger(true);
  }

  const handleCloseProOptionModal = () => {
    setProOptionModalTrigger(false);
  }

  const handleProOption = (ele) => {
    setProOptionId(ele.option_id_ids);
    setProOptionErr(false);
  }

  const handleSubmitProOption = () => {
    if (proOptionId) {
      setProOptionLoading(true);
      let data = new FormData();
      data.append('user_id_ids', localStorage.getItem('user_id'));
      data.append('pro_option', proOptionId);

      dispatch(
        updateProOptionApi(data,
          (res) => {
            setProOptionLoading(false);
            setResponceMsg(res.data.message)
            // setToasterType("success")
            handleCloseProOptionModal();
            // setHandleToaster(true);
            handleGetUserById();
            navigate("/dashboard");

            // if (serviceReqOptionId !== 1 && !proExpertiseFlag && !proDocumentsFlag) {
            //   navigate("/onBoardPro");
            // }

            // setTimeout(() => {
            //   setHandleToaster(false);
            // }, 5000);
          },
          (res) => {
            setProOptionLoading(false);
            setResponceMsg(res.data.message)
            setToasterType("error")
            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 5000);
          })
      )
    } else {
      setProOptionErr(true);
    }
  }
  // ---- Update Pro Option function ends here -------

  const [companyInvitationObj, setCompanyInvitationObj] = useState({})
  const [proAcceptCompanyReqModal, setProAcceptCompanyReqModal] = useState(false)
  const [invitationsArr, setInvitationsArr] = useState([])
  const [invitationLoading, setInvitationLoading] = useState(false);

  const handleOpenProAcceptCompanyReqModal = () => {
    setProAcceptCompanyReqModal(true)
  }

  const handleCloseProAcceptCompanyReqModal = () => {
    setProAcceptCompanyReqModal(false);
    dispatch(setIsSignUpFlagFalse())
    setCompanyInvitationObj({})
  }

  const getCompanyInvitationFn = () => {


    const data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id"));
    data.append("pagination_flag", 1);
    data.append("page_index", 1);
    data.append("page_size", 5);

    dispatch(
      getCompanyInvitationApi(data, (res) => {
        setInvitationsArr(res.data.data);
      }, (err) => {
      })
    );
    return;
  }

  useEffect(() => {
    if (permissionArray.includes("VIEW OPEN SERVICE REQUESTS") && !companyId) {
      getCompanyInvitationFn();
    }
  }, [companyId])


  useEffect(() => {
    if (invitationsArr?.length > 0) {
      setCompanyInvitationObj(invitationsArr[0])
      if (permissionArray.includes("VIEW OPEN SERVICE REQUESTS") && !companyId) {
        if ((invitationsArr?.[0]?.invitation_type_int === 1) && (invitationsArr?.[0]?.status_int === 0)) {
          handleOpenProAcceptCompanyReqModal()
        }
      }
    }
  }, [invitationsArr])

  const handleProAcceptCompanyRequest = () => {

    let data = new FormData();
    data.append('company_invitation_token', companyInvitationObj?.company_invitation_code);
    data.append('user_id_ids', localStorage.getItem('user_id'));

    setInvitationLoading(true);

    // dispatch(updateBackDropLoaderWithoutStateTrue());

    dispatch(acceptCompanyInvitationApi(data, (res) => {

      console.log(res, "res acceptCompanyInvitationApi");
      // setSuccessMsg(res?.data?.message);
      setInvitationLoading(false);
      handleCloseProAcceptCompanyReqModal();
      handleGetUserById();

    }, (err) => {
      console.log(err, "err acceptCompanyInvitationApi");
      // setCustomLoading(false);
      setInvitationLoading(false);
      setResponceMsg(err?.data?.message);
      setToasterType("error");

      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 4000);

    }))
  }

  // Function for the switch role
  const [showDropdown, setShowDropdown] = useState(false);

  const handleToggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  const [switchRoleLoading, setSwitchRoleLoading] = useState(false);
  const switchUserRoleFn = (ele) => {
    if (ele) {
      setSwitchRoleLoading(true);
      localStorage.setItem("roleId", ele?.role_id_ids)

      let data = {
        role_id_int: localStorage.getItem("roleId")
      }
      dispatch(switchRoleApi(data, (res) => {
        localStorage.setItem("access_token", res.data.access_token)
        localStorage.setItem("refresh_token", res.data.refresh_token)
        dispatch(setUserDetails(res.data.data))
        navigate("/dashboard")
        // setToasterType("success");
        // setHandleToaster(true);

        // setTimeout(() => {
        //   setHandleToaster(false);
        // }, 11000);

        setSwitchRoleLoading(false)
        closeDropdown();

      }, (err) => {
        setResponceMsg(err.data.message);
        setSwitchRoleLoading(false)
        setToasterType("error");
        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }
  }

  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <>

      <div className="d-flex " style={{ justifyContent: "flex-end" }}>
        <div
          className="header-width header-content"
          style={{
            height: "76px",

            position: "fixed",
            background: "#ffffff",
            zIndex: "10",
            // top: downloadAppBar ? "110px" : "0",
            top: "0",
          }}>
          <nav className="navbar navbar-expand p-0">
            <div
              className="d-flex my-0"
              style={{
                width: "100%",
                justifyContent: "space-between",
              }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  onClick={() => {
                    setToggle(!toggle);
                    //openMenuToggle();
                    NavMenuToggle();
                  }}
                  style={{ marginRight: "26px" }}>
                  {true && (
                    <div className="hamburgerDiv ms-3">
                      <div className="hamburgerLine"></div>
                      <div className="hamburgerLine"></div>
                      <div className="hamburgerLine"></div>
                    </div>
                  )}

                  {!toggle && false && (
                    <div className="hamburgerDiv ms-3 ">
                      {/* <BsArrowLeft
                        style={{ fontWeight: "bold", fontSize: "45px" }}
                      /> */}
                      <i class="bi bi-x-lg" style={{ fontWeight: "bold", fontSize: "26px" }}></i>
                      {/* < BsArrowLeftSquareFill style={{fontWeight:'bold',fontSize:'45px'}}/> */}
                    </div>
                  )}
                </div>
                <span
                  className="fs-3"
                  style={{ color: "black", fontWeight: "800" }}>
                  {currentPage}
                </span>
                {/* <img onClick={handleDashboard} src={logo} style={{ width: "136px", cursor: "pointer" }} alt="" /> */}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}>

                {/* <OverlayTrigger placement="bottom" overlay={shortcut}> */}
                {/* {role != 2 && <div
                  className="font-w500 available-switch"
                  style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", marginRight: '22px', marginTop: '9px' }}
                >
                  {loaderEffect ?
                    <Spinner animation="border" size='lg' style={{ width: '15px', height: '15px', color: 'orange' }} /> :
                    <Form>
                      <Form.Check
                        type="switch"
                        id="custom-switch"
                        label={isChecked ? "Pause jobs" : "Ready for Jobs"}
                        checked={isChecked}
                        onChange={() => handleToggle()}
                        style={{ color: 'black', pointerEvents: loaderEffect ? 'none' : 'auto', opacity: loaderEffect ? '0.5' : '1' }}
                      />
                    </Form>}
                </div>} */}
                {/* </OverlayTrigger> */}

                {/* Credit balance for customer */}
                {(permissionArray.includes("SCAN TAB")) &&
                  <>
                    <div
                      className="font-w500 susbscription-banner-header"
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        marginRight: "22px",
                      }}
                    >
                      <span
                        className="fs-7 px-3 py-1 text-white font-w700 rounded-3 position-relative"
                        style={{
                          background: "rgba(79, 93, 116, 1)",
                        }}>
                        <span>{`Available credits: `}</span>
                        <span className='font-w600'>{`${USDollar.format(totalCreditsInCents / 100)}`}</span>
                      </span>
                    </div>
                  </>
                }


                {/* (serviceRequestFlagPro !== 1) check removed because Pros connecting their own customers will get subscription plan */}
                {/* {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (role == 4)) && (serviceRequestFlagPro !== 1) && (permissionArray.includes("SUBSCRIPTION ENABLE")) && */}
                {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (role == 4)) && (permissionArray.includes("SUBSCRIPTION ENABLE")) &&
                  <>
                    {/* <OverlayTrigger placement="bottom" overlay={upgradeSubscription}> */}
                    <div
                      className="font-w500 cursor-pointer susbscription-banner-header"
                      style={{
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        marginRight: "22px",
                      }}
                      onClick={() => {
                        navigate('/userProfile')
                        dispatch(setUserProfileTab(5))
                      }}
                    >
                      <span
                        className="fs-7 px-3 py-1 text-white font-w700 rounded-3 position-relative"
                        style={{
                          background: "rgba(79, 93, 116, 1)",
                        }}>
                        {subscriptionTimeLeft > 0 ?
                          <>
                            {isFreeTrialSubscription ? `Free trial ends in ${subscriptionTimeLeft} day(s)` : (subscriptionType === "Paid" && subscriptionPaidStatus === "active") ? `Subscription renews in ${subscriptionTimeLeft} day(s)` : `Subscription ends in ${subscriptionTimeLeft} day(s)`}
                          </> :
                          `Upgrade`
                        }
                        {/* <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger fs-7 border border-2 border-white">
                          {`${subscriptionTimeLeft}`}
                        </span> */}
                      </span>
                    </div>
                    {/* </OverlayTrigger> */}
                  </>
                }

                {tabPermission.includes("GIVE FEEDBACK") && <OverlayTrigger placement="bottom" overlay={feedback}>
                  <div
                    className="font-w500 "
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      marginRight: "22px",
                    }}
                    onClick={() => {
                      setFeedbackModal(true)
                    }}>
                    <p className="d-flex align-items-center justify-content-center notification-bell">
                      <img src={feedbackIcon} />
                    </p>
                  </div>
                </OverlayTrigger>}

                {impersonateFlag && (
                  <OverlayTrigger placement="bottom" overlay={impersonate}>
                    <div
                      className="font-w500 shortcut-icon"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        marginRight: "22px",
                      }}
                      onClick={() => {
                        setImpersonateModal(true);
                      }}>
                      <p className="d-flex align-items-center justify-content-center notification-bell">
                        <BiReset />
                      </p>
                    </div>
                  </OverlayTrigger>
                )}

                <OverlayTrigger placement="bottom" overlay={shortcut}>
                  <div
                    className="font-w500 shortcut-icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      marginRight: "22px",
                    }}
                    onClick={() => {
                      downloadURLShortcut(
                        process.env.REACT_APP_MY_ENV,
                        "Chilll.url"
                      );
                    }}>
                    <p className="d-flex align-items-center justify-content-center notification-bell">
                      <i class="bi bi-file-earmark-arrow-down-fill"></i>
                    </p>
                  </div>
                </OverlayTrigger>

                <OverlayTrigger placement="bottom" overlay={notificationShr}>
                  <Dropdown
                    className=" header-profile2 "
                    style={{
                      marginRight: "6px",
                      display: "flex",
                      alignItems: "center",
                    }}>
                    <Dropdown.Toggle
                      id="dropdown-autoclose-inside"
                      className={`nav-link i-false cursor-pointer `}
                      style={{
                        padding: "0px",
                        background: "none",
                        border: "none",
                      }}>
                      <div
                        className="font-w500 mb-0 d-flex align-items-center justify-content-center"
                        style={{ position: "relative" }}
                        onClick={handleClickNotification}>
                        <p className="d-flex align-items-center justify-content-center notification-bell">
                          {notificationCount > 0 && (
                            <div className="notification-alert-back">
                              <div className="notification-alert-icon"></div>
                            </div>
                          )}

                          <i className="bi bi-bell"></i>
                          {notificationCount > 0 && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-14px",
                                right: "-10px",
                                fontSize: "13px",
                              }}>
                              {notificationCount}
                            </span>
                          )}
                        </p>
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-side"
                      style={{
                        position: "absolute",
                        inset: "0px -164px auto auto !important",
                        transform: " translate3d(0px, 69.6296px, 0px)",
                        width: "360px",

                        overflow: "auto",
                      }}>
                      <div
                        className=" d-flex align-items-center"
                        style={{
                          justifyContent: "space-between",
                          padding: "0.5rem 1.75rem",
                        }}>
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "black",
                          }}>
                          Notifications
                        </div>
                      </div>
                      <hr style={{ margin: "0" }} />

                      <Dropdown.Item href="#" style={{ padding: "0px", cursor: "default" }}>
                        {" "}
                        <div
                          className=" d-flex align-items-center"
                          style={{
                            justifyContent: "flex-end",
                            padding: "0.5rem 1.75rem",
                          }}>
                          <Button
                            className="notification-btn"
                            variant="primary"
                            style={{
                              background: "white",
                              color: "black",
                              marginRight: "10px",
                              fontSize: "11px",
                              border: "2px solid #D8E0F0",
                              fontWeight: "600",
                              pointerEvents: notificationsLoading ? "none" : "auto",
                              opacity: notificationsLoading ? '0.5' : '1',
                            }}
                            onClick={handleReadAllNotification}>
                            Read All
                          </Button>

                          {tabPermission.includes("HOME TAB") && <Button
                            onClick={() => notificationPage()}
                            className="notification-btn"
                            variant="primary"
                            style={{
                              background: "#0AC947",
                              color: "white",
                              border: "none",
                              fontSize: "11px",
                              fontWeight: "600",
                            }}>
                            View All
                          </Button>}
                        </div>
                      </Dropdown.Item>

                      <div
                        style={{
                          height: "100dvh",
                          overflow: "auto",
                          pointerEvents: notificationsLoading ? "none" : "auto",
                          opacity: notificationsLoading ? '0.5' : '1',
                        }}
                      >
                        {" "}

                        {/* {notificationArr.length === 0 &&
                          <div className="px-1">
                            <SkeletonDivElement
                              height={"50px"}
                              rows={16}
                              marginBottom={'5px'}
                              borderRadius={'6px'}
                            />
                          </div>
                        } */}

                        {notificationLoading ?
                          <>
                            <div className="px-1">
                              <SkeletonDivElement
                                height={"50px"}
                                rows={16}
                                marginBottom={'5px'}
                                borderRadius={'6px'}
                              />
                            </div>
                          </> : <>
                            {notificationArr?.length > 0 ?
                              <>
                                {notificationArr.map(
                                  (
                                    {
                                      message_chr,
                                      is_read_ysn,
                                      notification_id_ids,
                                      notification_type_int,
                                      status_ysn,
                                      ticket_id_ids,
                                      updated_date_dtm,
                                      call_log_id_ids,
                                      preferred_profile_picture_url,
                                      ticket_id_lng,
                                      notification_image_path_chr,
                                    },
                                    index
                                  ) => {
                                    return (
                                      <div style={{ display: "flex" }}>
                                        <Dropdown.Item
                                          href="#"
                                          style={{ padding: "0px" }}>
                                          <div
                                            className="d-flex notification-list-modal-item py-2"
                                            style={{
                                              height: "",
                                              alignItems: "center",
                                            }}
                                            onClick={() => {
                                              handleMenuItemClick(
                                                notification_id_ids,
                                                call_log_id_ids,
                                                notification_type_int,
                                                ticket_id_ids,
                                                ticket_id_lng
                                              );
                                            }}>
                                            <div
                                              className="d-flex justify-content-center"
                                              style={{ width: "20%" }}>
                                              <img
                                                style={{
                                                  width: "70%",
                                                  height: "70%",
                                                  borderRadius: "100%",
                                                }}
                                                // src={profilePicture}
                                                src={preferred_profile_picture_url}
                                                alt=""
                                              />
                                            </div>
                                            <div
                                              className="d-flex"
                                              style={{
                                                width: "78%",
                                                flexDirection: "column",
                                              }}>
                                              <p
                                                style={{
                                                  color: "black",
                                                  fontWeight:
                                                    is_read_ysn == 0 ? "600" : "300",
                                                  margin: "0px",
                                                  fontSize: "11px",
                                                  textOverflow: "ellipsis",
                                                  whiteSpace: "break-spaces",
                                                }}>
                                                {" "}
                                                {message_chr}
                                              </p>

                                              {notification_image_path_chr &&
                                                <div className="row mx-0">
                                                  <div className="col-12 px-0 d-flex align-items-center justify-content-end">
                                                    <img
                                                      className="img-fluid rounded-2"
                                                      style={{
                                                        width: "35px",
                                                        height: "35px",
                                                      }}
                                                      src={notification_image_path_chr}
                                                      alt=""
                                                    />
                                                  </div>
                                                </div>
                                              }

                                              <div className="row mx-0">
                                                <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                                  <div style={{ fontSize: "11px" }}>
                                                    {ticket_id_lng ?
                                                      <span
                                                        className="text-hovered font-w600"
                                                        style={{ color: 'rgb(131, 154, 192)' }}
                                                        onClick={(e) => {
                                                          if (notification_type_int == 8) {
                                                            e?.stopPropagation();
                                                            navigate('/userProfile')
                                                            dispatch(setUserProfileTab(3))
                                                          } else {
                                                            localStorage.setItem("ticket_id", ticket_id_lng);
                                                            navigate("/serviceRequestDetails");
                                                          }

                                                        }}
                                                      >
                                                        {notification_type_int == 8 ? `Resolve this` : `See details`}
                                                        <i className="bi bi-chevron-right ms-2" />
                                                      </span>
                                                      :
                                                      <>
                                                        {
                                                          notification_type_int == 8 &&
                                                          <>
                                                            <span
                                                              className="text-hovered font-w600"
                                                              style={{ color: 'rgb(131, 154, 192)' }}
                                                              onClick={(e) => {
                                                                // e?.stopPropagation();
                                                                navigate('/userProfile')
                                                                dispatch(setUserProfileTab(3))
                                                              }}
                                                            >
                                                              {`Resolve`}
                                                              <i className="bi bi-chevron-right ms-2" />
                                                            </span>
                                                          </>
                                                        }

                                                      </>
                                                    }
                                                  </div>



                                                  <div style={{ fontSize: "11px" }}>
                                                    {updated_date_dtm != null
                                                      ? new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "long",
                                                        day: "numeric",
                                                      }).format(updated_date_dtm + "000")
                                                      : ""}
                                                  </div>
                                                </div>
                                              </div>

                                            </div>
                                          </div>
                                          {index < notificationArr?.length - 1 && (
                                            <hr style={{ margin: "0" }} />
                                          )}
                                        </Dropdown.Item>
                                        <div
                                          className="d-flex justify-content-center"
                                          style={{
                                            width: "10%",
                                            color: "red",
                                            fontWeight: "700",
                                            alignItems: "center",
                                            borderBottom: "0.5px solid currentColor",
                                          }}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-x-lg"
                                            viewBox="0 0 16 16"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              deleteSingleDetails(
                                                notification_id_ids,
                                                index
                                              );
                                            }}>
                                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                                          </svg>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </> : <>
                                <div className="row mx-0">
                                  <div className="col-12 px-0">
                                    <div className="d-flex justify-content-center align-items-center flex-column my-5">
                                      <img src={bell} style={{ width: "70px", height: "70px" }} alt="" />
                                      <span className="mt-3">{`No notifications to show yet`}</span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            }
                          </>
                        }

                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </OverlayTrigger>
                <div className="d-flex align-items-center justify-content-sm-end justify-content-end">
                  <ul className="navbar-nav header-right">
                    <li>
                      <Dropdown className=" header-profile2 " show={showDropdown} onToggle={handleToggleDropdown}>
                        <Dropdown.Toggle
                          as="a"
                          className={`nav-link i-false cursor-pointer bg-transparent`}
                          id="droptoggle1">
                          <div className="header-info2 d-flex align-items-center">
                            <img src={profilePicture} alt="" />
                            <div className="d-flex align-items-center sidebar-info">
                              <div>
                                <h6
                                  className="font-w500 mb-0 ms-2"
                                  style={{ color: "#000000" }}>
                                  {userName?.split(" ", 1)}
                                </h6>
                              </div>
                              <i
                                className="fas fa-chevron-down"
                                style={{ color: "#000000" }}></i>
                            </div>
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-end">
                          {tabPermission.includes("HOME TAB") && <Link
                            to="./userProfile"
                            className="dropdown-item ai-icon "
                            onClick={closeDropdown}
                          >
                            {/* <svg  xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> */}
                            <i
                              className="bi bi-person text-primary"
                              style={{ fontSize: "18px" }}></i>
                            <span className="ms-2">{btnPersonal}</span>
                          </Link>}

                          {/* {roleArr?.length > 1 && (
                            <Link
                              onClick={() => {
                                setSwitchRoleModal(true);
                              }}
                              className="dropdown-item ai-icon">
                              <PiUserSwitchBold
                                style={{ fontSize: "18px" }}
                                className="bi bi-lock text-primary"
                              />

                              <span className="ms-2">{"Switch Role"}</span>
                            </Link>
                          )} */}

                          {permissionArray.includes("UPDATE WORK INFORMATION") && (
                            <Link
                              onClick={(e) => {
                                handleOpenUseChilllModal(e);
                                closeDropdown();
                              }}
                              className="dropdown-item ai-icon"
                            >
                              <i
                                className="bi bi-gear text-primary"
                                style={{ fontSize: "18px" }}></i>
                              <span className="ms-2">{"Use Chilll to"}</span>
                            </Link>
                          )}

                          {permissionArray.includes("UPDATE WORK INFORMATION") && (
                            <Link
                              onClick={(e) => {
                                handleOpenProOptionModal(e);
                                closeDropdown();
                              }}
                              className="dropdown-item ai-icon"
                            >
                              <i
                                className="bi bi-person-gear text-primary"
                                style={{ fontSize: "18px" }}></i>
                              <span className="ms-2">{"Update Pro type"}</span>
                            </Link>
                          )}


                          <Link
                            onClick={() => {
                              handleShowInviteFriend()
                              closeDropdown()
                            }}
                            className="dropdown-item ai-icon">
                            {/* <svg  xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg> */}
                            <i
                              className="bi bi-people text-primary"
                              style={{ fontSize: "18px" }}></i>
                            <span className="ms-2">{btnInviteFriends}</span>
                          </Link>
                          {tabPermission.includes("HOME TAB") && <Link
                            onClick={() => {
                              handleShowChangePassword()
                              closeDropdown()
                            }}
                            className="dropdown-item ai-icon">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" ><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> */}
                            <i
                              className="bi bi-lock text-primary"
                              style={{ fontSize: "18px" }}></i>
                            <span className="ms-2">{btnChangePassword}</span>
                          </Link>}

                          {(tabPermission.includes("CREATE PROJECT TAB") || tabPermission.includes("ASSIGN SERVICE REQUEST")) && <Link
                            to="./myDiyProject"
                            className="dropdown-item ai-icon "
                            onClick={closeDropdown}
                          >
                            {/* <svg  xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> */}
                            <i
                              className="bi bi-book text-primary"
                              style={{ fontSize: "18px" }}></i>
                            <span className="ms-2">{`DIY Projects`}</span>
                          </Link>}

                          {roleArr?.length > 1 &&
                            <div className="row w-100 ">
                              <div
                                className="col-12 px-0 bg-white"
                                style={{
                                  pointerEvents: switchRoleLoading ? 'none' : 'auto',
                                  opacity: switchRoleLoading ? '0.5' : '1',
                                }}
                              >

                                <div className="dropdown-divider"></div>
                                <div>
                                  <div className="">
                                    <div className="px-2 mb-2 d-flex justify-content-between align-items-center">
                                      <span className="fs-7 font-w600 text-black">{`Switch Account`}</span>

                                      {switchRoleLoading && <div className="ps-2">
                                        <Spinner variant="primary" animation="border" size="sm" style={{ fontSize: '15px' }} />
                                      </div>}
                                    </div>

                                    <div>
                                      {roleArr.map((element, ind) => {
                                        return (
                                          <>
                                            {role !== element?.role_id_ids && (
                                              <div
                                                className="d-flex align-items-center overlay-action-btn cursor-pointer p-2"
                                                onClick={() => { switchUserRoleFn(element) }}
                                              >
                                                <div className="d-flex justify-content-center align-items-center">
                                                  <img src={profilePicture} className="rounded-circle border" style={{ width: '25px', height: '25px' }} alt="" />
                                                </div>
                                                <div className="ms-3" style={{ lineHeight: '1.2' }}>
                                                  <div>
                                                    <span className="font-w500 text-black">{`${userName} ${userLastName}`}</span>
                                                  </div>
                                                  <div>
                                                    <span className="fs-7 text-truncate ">{`${element?.role_display_name_chr}`}</span>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        )
                                      })}
                                    </div>
                                  </div>
                                </div>


                                <div className="dropdown-divider"> </div>
                              </div>
                            </div>
                          }

                          <LogoutPage />
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>
          {activeCalls.length > 0 && isActiveCall &&
            <a
              className="w-100 d-flex justify-content-center align-items-center cursor-pointer text-white font-w600 rounded-2 border-hovered"
              style={{ background: '#15b315', height: '40px', }}
              href={activeCalls[0]?.video_link_chr}
            >
              <div className="row w-100">
                <div className="col-12 px-4 d-flex justify-content-between align-items-center">
                  <div className="rounded-circle" style={{ width: '15px', height: '15px', background: 'red' }}>
                  </div>

                  <div className="px-2">
                    <span >{`${activeCalls[0]?.category_name_chr || ''} call going on right now`}</span>
                  </div>

                  <div className="d-flex">
                    <span
                      className="align-items-center border border-3 border-white cursor-pointer d-flex justify-content-center overlay-action-btn px-2 rounded-circle text-white"
                      style={{
                        height: '25px',
                        width: '25px',
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation()
                        dispatch(setInactiveCall())
                      }}
                    >
                      <i className="bi bi-x-lg" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </div>
            </a>
          }
        </div>

      </div>

      {callStatus && (
        <PhoneCallModal
          openCallUI={callStatus}
          dataRecieved={recievedFromServer}
          errorFunction={(text) => {
            setErrorMessage(text)
            setErrorModalStatus(true)
          }}
        />
      )}

      {errorModalStatus && <ErrorResponseModal
        text={errorMessage}
        onClick={() => {
          setErrorModalStatus(!errorModalStatus);
          if (recievedFromServer?.data?.notification_type == "8") {
            navigate('/userProfile')
            dispatch(setUserProfileTab(3))
          }
        }}
        modalStatus={errorModalStatus}
      />}

      {showInviteFriend && (
        <InviteFriend
          inviteFriendTrigger={showInviteFriend}
          handleCloseInviteFriend={handleCloseInviteFriend}
        />
      )}
      {showChangePassword && (
        <ChangePassword
          changePasswordTrigger={showChangePassword}
          handleCloseChangePassword={handleCloseChangePassword}
        />
      )}
      {handleToaster && (
        <ResponceToaster toasterType={toasterType} message={responceMsg} />
      )}
      <FcmTokenVerify
        FcmModalTrigger={FcmModalTrigger}
        handleCloseFCM={handleCloseFCM}
        titleTXT={"Failed to set calling protocol"}
        bodyTXT={
          "You will not receive any call. Please allow your notification for this site or turn off incognitive mode and then refresh"
        }
      />
      <AcceptRejectModal
        text={"Are you sure you want to revert impersination ?"}
        modalStatus={impersonateModal}
        onClickAccept={handleRevertimpersonate}
        onClickReject={() => setImpersonateModal(false)}
      />

      {/* <SwitchRole
        changeDefaultRole={(e, n) => {
          setChangedRoleId(e);
          setRoleName(n);
        }}
        modalStatus={switchRoleModal}
        onClose={handleSwitchRoleModalClose}
        rolesArray={roleArr}
        defaultRoleId={changedRoleId}
        defaultUserRoleName={roleName}
      /> */}

      {/* Modal for the Use Chilll As*/}
      <Modal className='fade' centered show={useChilllModalTrigger}>
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-11 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {"Use Chilll to"}
                    </span>
                  </div>
                  <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                    <span onClick={() => handleCloseUseChilllModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                <div className='row mb-4'>
                  <div className='col-12 px-0'>
                    {serviceRequestOptions?.map((ele, index) => {
                      return (
                        <div key={index} className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { handleServiceRequestoption(ele) }}>
                          <div className='col-12 font-w500 fs-4 px-0 '>
                            <div className={`${index !== (serviceRequestOptions.length - 1) && "border-bottom"} mx-0 p-2 row `}>
                              <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                <input
                                  className="form-check-input d-flex"
                                  type="radio"
                                  name="avatar"
                                  value={ele.option_id_ids}
                                  onChange={(e) => setServiceReqOptionId(ele.option_id_ids)}
                                  checked={ele.option_id_ids === serviceReqOptionId}
                                />
                              </div>

                              <div className={`align-items-cente col-10 d-flex px-0 ${ele.option_id_ids === serviceReqOptionId ? "font-w600" : "font-w500"}`}>
                                <span>
                                  {ele.option_value_chr}
                                </span>
                              </div>

                            </div>

                          </div>
                        </div>
                      )
                    })}

                    {serviceReqOptionErr &&
                      <span className='text-danger'>{`Please select option`}</span>
                    }
                  </div>
                </div>



                <div className='row mx-0 mt-2'>
                  <div className='col-12 px-0'>
                    <PrimaryButton
                      onClick={() => {
                        // uploadProfessionalDocuments()
                        handleSubmitServiceReqOption()
                      }}
                      buttonName={"SUBMIT"}
                      type="submit"
                      loadingMessage="SUBMITTING..."
                      isLoading={serviceReqOptionLoading}
                      style={{
                        width: "100%",
                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        border: '1px solid rgba(255, 154, 32, 1)',
                        fontWeight: '600',
                      }}
                    />
                  </div>
                </div>
              </>

            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* Modal for the Update Pro Type */}
      <Modal className='fade' centered show={proOptionModalTrigger}>
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-11 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {"Update Pro Type"}
                    </span>
                  </div>
                  <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                    <span onClick={() => handleCloseProOptionModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                {/* <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Do you `}
                                        </span>
                                    </div>
                                </div> */}

                <div className='row mb-4'>
                  <div className='col-12 px-0'>
                    {proOptionList?.map((ele, index) => {
                      return (
                        <div key={index} className='mx-0 row lh-lg cursor-pointer overlay-action-btn text-black' onClick={() => { handleProOption(ele) }}>
                          <div className='col-12 font-w500 fs-4 px-0 '>
                            <div className={`${index !== (proOptionList.length - 1) && "border-bottom"} mx-0 p-2 row `}>
                              <div className="align-items-cente col-2 d-flex px-0 justify-content-center">
                                <input
                                  className="form-check-input d-flex"
                                  type="radio"
                                  name="avatar"
                                  value={ele.option_id_ids}
                                  onChange={(e) => setProOptionId(ele.option_id_ids)}
                                  checked={ele.option_id_ids === proOptionId}
                                />
                              </div>

                              <div className={`align-items-cente col-10 d-flex px-0 ${ele.option_id_ids === proOptionId ? "font-w600" : "font-w500"}`}>
                                <span>
                                  {ele.option_value_chr}
                                </span>
                              </div>

                            </div>

                          </div>
                        </div>
                      )
                    })}

                    {proOptionErr &&
                      <span className='text-danger'>{`Please select option`}</span>
                    }
                  </div>
                </div>



                <div className='row mx-0 mt-2'>
                  <div className='col-12 px-0'>
                    <PrimaryButton
                      onClick={() => {
                        // uploadProfessionalDocuments()
                        handleSubmitProOption()
                      }}
                      buttonName={"SUBMIT"}
                      type="submit"
                      loadingMessage="SUBMITTING..."
                      isLoading={proOptionLoading}
                      style={{
                        width: "100%",
                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                        border: '1px solid rgba(255, 154, 32, 1)',
                        fontWeight: '600',
                      }}
                    />
                  </div>
                </div>
              </>

            </div>
          </div>
        </Modal.Body>
      </Modal >

      <SwitchRole
        // changeDefaultRole={(e, n) => {
        //   setChangedRoleId(e);
        //   setRoleName(n);
        // }}
        modalStatus={switchRoleModal}
        onClose={handleSwitchRoleModalClose}
        rolesArray={roleArr}
        defaultRoleId={role}
        defaultUserRoleName={roleDisplayName}
      />

      {feedbackModal && <FeedbackModal
        onBlur={() => { setFeedbackModal(feedbackModal) }}
        addUserTrigger={feedbackModal}
        handleCloseAddUser={handleFeedbackModal}
      />}


      <Modal
        show={callModal}
        onHide={() => { setCallModal(false) }}
        dialogClassName="modal-90w"
      >
        <Modal.Header>
          <h5>
            Please join the active call
          </h5>
          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => { setCallModal(false) }}
          >
          </Button>
        </Modal.Header>
        <Modal.Body>
          {activeCalls.map((res) => (

            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
              <p style={{ margin: '0px' }}>
                Active {res.category_name_chr} call, Please join clicking here

              </p>

              <a href={res.video_link_chr} rel="noreferrer">
                <i class="bi bi-camera-video-fill" style={{ color: 'green', fontSize: '20px' }}></i>
              </a></div>

          ))
          }
        </Modal.Body>
      </Modal>

      {/* Modal for accept company request by pro */}
      <Modal className='fade' centered
        show={proAcceptCompanyReqModal && isSignUpFlag}
      >
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-11 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {"Accept company request"}
                    </span>
                  </div>
                  <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                    <span
                      onClick={() => {
                        handleCloseProAcceptCompanyReqModal()
                      }}
                      className='cursor-pointer fs-4 text-black text-hovered'
                    >
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                <>
                  <div className='fs-4 font-w600 text-black text-center mb-5'>
                    <span>
                      {`${companyInvitationObj?.company_name_chr} has sent you a request to join as ${companyInvitationObj.role_display_name_chr}`}
                    </span>
                  </div>

                  <div className='fs-5 font-w500 d-flex mt-3'>
                    <div className='d-flex me-2' style={{ color: '#4e5d74', width: '115px' }}>
                      <span>
                        <i className="fa fa-info-circle me-2" ></i>
                      </span>
                      <span className='font-w600'>{`Note:`}</span>
                    </div>
                    <div>
                      <span>{`Your current subscription will be cancelled after joining the company`}</span>
                    </div>
                  </div>

                  <div className='row mt-5 w-100 '>

                    <div className='col-6 pe-2 mt-2'>
                      <PrimaryButton
                        buttonName={`CANCEL`}
                        onClick={(e) => {
                          handleCloseProAcceptCompanyReqModal()
                        }}
                        loadingMessage={"Saving..."}
                        isLoading={false}
                        style={{
                          width: '100%',
                          background: '#4e5d74',
                          border: 'none',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                    <div className='col-6 ps-2 mt-2'>
                      <PrimaryButton
                        buttonName={`ACCEPT`}
                        onClick={(e) => {
                          handleProAcceptCompanyRequest()
                        }}
                        loadingMessage={"ACCEPTING..."}
                        isLoading={invitationLoading}
                        style={{
                          width: '100%',
                          border: 'none',
                          background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                          boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>
                  </div>
                </>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal for notification type 13 */}
      <Modal
        className="fade"
        show={globalNotificationModalTrigger}
        // onHide={handleClose}
        centered
      >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => { setGlobalNotificationModalTrigger(false) }}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  {/* <i className='bi bi-check2-circle text-success' style={{ fontSize: '100px' }} /> */}
                  <img src={imageLogo} style={{ width: "100px" }} className="mb-4" alt='logo' />
                </div>
              </div>


              {globalNotificationData?.title && <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <span className="text-center">{globalNotificationData?.title}</span>
                </div>
              </div>}

              {globalNotificationData?.body &&
                <div className="row mx-0 mb-3 pb-2">
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                    <p className="fs-4 text-center font-w600">
                      {globalNotificationData?.body}
                    </p>
                  </div>
                </div>
              }

              {globalNotificationData?.image_url &&
                <div className="row mx-0 pb-2">
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center">

                    <img className="rounded-2" src={globalNotificationData?.image_url} style={{ width: '100%', maxHeight: '300px', objectFit: 'cover' }} alt="notification attachment" />

                  </div>
                </div>
              }


              <div className="row mx-0 text-black mt-2">
                <div className="col-12 font-w600 mb-2 d-flex justify-content-center">
                  <PrimaryButton
                    onClick={() => { setGlobalNotificationModalTrigger(false) }}
                    buttonName={"CLOSE"}
                    style={{
                      width: "auto",
                      border: 'none',
                      background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                      boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal for Pro's connceting to their own customers giving them free trial */}
      <Modal
        className="fade"
        show={isSignUpFlag && serviceRequestFlagPro == 1 && isFreeTrialSubscription && subscriptionTimeLeft}
        // onHide={handleClose}
        centered
      >
        <Modal.Body>
          <div className="row mx-0">
            <div className="col-12 px-0">
              <div className="row mx-0">
                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                  <span
                    onClick={() => { dispatch(setIsSignUpFlagFalse()) }}
                    className="cursor-pointer">
                    <i className="bi bi-x-lg"></i>
                  </span>
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <i className='bi bi-check2-circle text-success' style={{ fontSize: '100px' }} />
                </div>
              </div>

              <div className="row mx-0 mb-3">
                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                  <span className="text-center">{'Congratulations!'}</span>
                </div>
              </div>

              <div className="row mx-0 mt-3 pb-2">
                <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                  {/* <span className="fs-5 text-center">
                                                    {"Measuring feature is avaible on mobile devices. Please download Chilll app from playstore or appstore to use this feature."}
                                                </span> */}

                  <p className="fs-4 text-center font-w600">
                    Welcome aboard! You have received <span className="font-w600 text-black">{`${subscriptionTimeLeft}`} days </span> free trial to use in Chilll services.
                  </p>
                </div>
              </div>

              <div className="row mx-0 text-black mt-2">
                <div className="col-12 font-w600 mb-2 d-flex justify-content-center">
                  <PrimaryButton
                    onClick={() => { dispatch(setIsSignUpFlagFalse()) }}
                    buttonName={"AWESOME"}
                    style={{
                      width: "auto",
                      border: 'none',
                      background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                      boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                      fontWeight: '600',
                    }}
                  />
                </div>
              </div>

            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
